// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var cashback_slab = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cashback_slab"), null));
  if (cashback_slab.TAG === /* Ok */0) {
    var cashback_balance = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cashback_balance"), null));
    if (cashback_balance.TAG === /* Ok */0) {
      var cashback_offered = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cashback_offered"), null));
      if (cashback_offered.TAG === /* Ok */0) {
        var cashback_redeemed = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cashback_redeemed"), null));
        if (cashback_redeemed.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    cashback_slab: cashback_slab._0,
                    cashback_balance: cashback_balance._0,
                    cashback_offered: cashback_offered._0,
                    cashback_redeemed: cashback_redeemed._0
                  }
                };
        }
        var e = cashback_redeemed._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".cashback_redeemed" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = cashback_offered._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".cashback_offered" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = cashback_balance._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".cashback_balance" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = cashback_slab._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".cashback_slab" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

export {
  t_decode ,
  
}
/* No side effect */
